import api from './http';

// Wallet & Credits
export const getWallet = () => api.get('/wallet');
export const getWalletLedger = (skip = 0, limit = 50, direction = null, type = null) => {
  let url = `/wallet/ledger?skip=${skip}&limit=${limit}`;
  if (direction) url += `&direction=${direction}`;
  if (type) url += `&type=${type}`;
  return api.get(url);
};
export const getCreditPacks = () => api.get('/wallet/packs');
export const getSubscriptionPlans = () => api.get('/wallet/plans');
export const getSubscription = () => api.get('/wallet/subscription');
export const createSubscription = (plan_id, billing_cycle = 'monthly') => api.post('/wallet/subscription', { plan_id, billing_cycle });
export const packCheckout = (packId) => api.post(`/wallet/packs/${packId}/checkout`);
export const confirmPackPurchase = (packId, sessionId) => api.post(`/wallet/packs/${packId}/confirm`, { session_id: sessionId });
export const getActionCosts = () => api.get('/wallet/action-costs');
export const consumeCredits = (action, refId = '') => api.post('/wallet/consume', { action, ref_id: refId });
export const getWalletAnalytics = (days = 30) => api.get(`/wallet/analytics?days=${days}`);
export const getWalletPredictions = () => api.get('/wallet/predictions');
export const getWalletSettings = () => api.get('/wallet/settings');
export const updateActionCosts = (action_costs) => api.put('/wallet/settings/action-costs', { action_costs });
export const updateAlertSettings = (settings) => api.put('/wallet/settings/alerts', settings);
export const getReferralInfo = () => api.get('/referral');
export const applyReferralCode = (code) => api.post('/referral/apply', { code });
export const seedWallet = () => api.post('/wallet/seed');
